import { push } from 'redux-little-router';
import { getStore } from 'configureStore';
import { get } from 'lodash';
import { readNotification, setWatched } from './redux/actions';
import { showNotificationModal, showToast } from 'modules/Notifications/redux/actions';
import { ERROR, NOTIFICATION } from 'modules/Toasts/constants/toastTypes';
import getLinkByCode from 'modules/Notifications/linkCodes';

const AWAITING_TIMEOUT = 1500;
const NOTIFICATION_DELAY = 350;
const DETAILS_DEFAULT = 'Подробнее';
const ids = [];
let isWaiting = null;

export const handleOnClose = (id, notificationId, eventTypeId) => () => {
  clearTimeout(isWaiting);
  ids.push({ notificationId, eventTypeId });

  isWaiting = setTimeout(() => {
    getStore().dispatch(setWatched([...ids]));
    ids.length = 0;
  }, AWAITING_TIMEOUT);
};

export const getLink = (siteMap, linkId, { notificationId, eventTypeId, cardId }) =>
  get(
    siteMap.find(({ LINK_ID }) => LINK_ID === linkId),
    'LINK',
    getLinkByCode(linkId, { notificationId, eventTypeId, cardId }),
  );

const decorateWithRead = (func, { id, notificationId, eventTypeId }) => {
  return function () {
    getStore().dispatch(readNotification({ id, notificationId, eventTypeId }));
    func.apply(null);
  };
};

const getLinkHandler = (siteMap, linkId, { id, notificationId, eventTypeId, cardId }) =>
  decorateWithRead(
    () => {
      const target = getLink(siteMap, linkId, {
        notificationId,
        eventTypeId,
        cardId,
      });

      if (target) {
        getStore().dispatch(push(target));
      }
    },
    { id, notificationId, eventTypeId },
  );

export const getContentHandler = ({ id, title, content, notificationId, eventTypeId }) =>
  decorateWithRead(
    () => {
      getStore().dispatch(showNotificationModal({ id, title, content }));
    },
    { id, notificationId, eventTypeId },
  );

export const onShowToastHandler = (siteMap, setOnClose) => (
  { id, subject, text, notificationId, eventTypeId, isImportant, link, isTextMessage, cardId },
  idx,
) => {
  const toastOptions = {
    toastId: id,
    delay: NOTIFICATION_DELAY * idx,
  };

  if (setOnClose) {
    toastOptions.onClose = handleOnClose(id, notificationId, eventTypeId);
  }

  if (link) {
    toastOptions.onClick = getLinkHandler(siteMap, link, {
      id,
      notificationId,
      eventTypeId,
      cardId,
    });
  } else if (isTextMessage) {
    toastOptions.onClick = getContentHandler({
      id,
      title: subject,
      content: text,
      notificationId,
      eventTypeId,
    });
  } else {
    toastOptions.onClick = () =>
      getStore().dispatch(readNotification({ id, notificationId, eventTypeId }));
  }

  getStore().dispatch(
    showToast({
      type: isImportant ? ERROR : NOTIFICATION,
      notification: {
        message: subject,
        details: !isTextMessage ? text : DETAILS_DEFAULT,
        options: toastOptions,
      },
    }),
  );
};
